import { createActions } from 'redux-actions';

import {
  CreateCorporateHealthQuoteParams,
  GetCorporateHealthQuoteParams,
  UpdateCorporateHealthQuoteParams,
  LockCorporateHealthQuoteParams,
  PayByCashCorporateHealthQuoteParams,
  GetUsersCorporateHealthQuoteParams,
  DeleteUserCorporateHealthQuoteParams,
  UpdateUserCorporateHealthQuoteParams,
  GetImportsCorporateHealthQuoteParams,
  CreateImportCorporateHealthQuoteParams,
  ExportActiveUsersCorporateHealthQuoteParams,
} from '@apis/CorporateHealthQuoteApi';
import { GetCorporateHealthOrderUserRemainingBenefitsParams } from '@apis/CorporateHealthOrderApi';
import { CorporateHealthQuote } from '@models/CorporateHealthQuote';
import { CorporateUser } from '@models/User';
import { Pagination } from '@models/Pagination';
import { ImportModel } from '@models/ImportModel';
import { CorporateHealthOrderUserRemainingBenefit } from '@models/CorporateHealthOrderUserRemainingBenefit';

export type State = {
  corporateHealthQuote?: CorporateHealthQuote | null;
  users: CorporateUser[];
  isUsersLoading: boolean;
  usersPagination: Pagination | null;
  imports: ImportModel[];
  corporateHealthOrderUserRemainingBenefits?: CorporateHealthOrderUserRemainingBenefit[] | null;
};

export type CorporateHealthQuoteCreatePayload = CreateCorporateHealthQuoteParams;
export type CorporateHealthQuoteFetchPayload = GetCorporateHealthQuoteParams;
export type CorporateHealthQuoteUpdatePayload = UpdateCorporateHealthQuoteParams;
export type CorporateHealthQuoteLockPayload = LockCorporateHealthQuoteParams;
export type CorporateHealthQuotePayByCashPayload = PayByCashCorporateHealthQuoteParams;
export type CorporateHealthQuoteGetUsersPayload = GetUsersCorporateHealthQuoteParams;
export type CorporateHealthQuoteUpdateUserPayload = UpdateUserCorporateHealthQuoteParams;
export type CorporateHealthQuoteDeleteUserPayload = DeleteUserCorporateHealthQuoteParams;
export type CorporateHealthQuoteGetImportsPayload = GetImportsCorporateHealthQuoteParams;
export type CorporateHealthQuoteCreateImportPayload = CreateImportCorporateHealthQuoteParams;
export type CorporateHealthQuoteExportActiveUsersPayload = ExportActiveUsersCorporateHealthQuoteParams;

export type CorporateHealthOrderUserRemainingBenefitsFetchPayload = GetCorporateHealthOrderUserRemainingBenefitsParams;

export type StateUpdatePayload = Partial<State>;

export const {
  corporateHealthQuoteCreate,
  corporateHealthQuoteFetch,
  corporateHealthQuoteUpdate,
  corporateHealthQuoteLock,
  corporateHealthQuotePayByCash,
  corporateHealthQuoteGetUsers,
  corporateHealthQuoteGetUsersSuccess,
  corporateHealthQuoteUpdateUser,
  corporateHealthQuoteUpdateUserSuccess,
  corporateHealthQuoteDeleteUser,
  corporateHealthQuoteDeleteUserSuccess,
  corporateHealthQuoteGetImports,
  corporateHealthQuoteCreateImport,
  corporateHealthQuoteCreateImportSuccess,
  corporateHealthQuoteExportActiveUsers,

  corporateHealthOrderUserRemainingBenefitsFetch,

  stateUpdate,
} = createActions(
  'CORPORATE_HEALTH_QUOTE_CREATE',
  'CORPORATE_HEALTH_QUOTE_FETCH',
  'CORPORATE_HEALTH_QUOTE_UPDATE',
  'CORPORATE_HEALTH_QUOTE_LOCK',
  'CORPORATE_HEALTH_QUOTE_PAY_BY_CASH',
  'CORPORATE_HEALTH_QUOTE_GET_USERS',
  'CORPORATE_HEALTH_QUOTE_GET_USERS_SUCCESS',
  'CORPORATE_HEALTH_QUOTE_UPDATE_USER',
  'CORPORATE_HEALTH_QUOTE_UPDATE_USER_SUCCESS',
  'CORPORATE_HEALTH_QUOTE_DELETE_USER',
  'CORPORATE_HEALTH_QUOTE_DELETE_USER_SUCCESS',
  'CORPORATE_HEALTH_QUOTE_GET_IMPORTS',
  'CORPORATE_HEALTH_QUOTE_CREATE_IMPORT',
  'CORPORATE_HEALTH_QUOTE_CREATE_IMPORT_SUCCESS',
  'CORPORATE_HEALTH_QUOTE_EXPORT_ACTIVE_USERS',

  'CORPORATE_HEALTH_ORDER_USER_REMAINING_BENEFITS_FETCH',

  'STATE_UPDATE',
  {
    prefix: 'CORPORATE_HEALTH_QUOTE_BUY_ROUTE',
  },
);
